import { TLocale } from '@internal/utils/machine/i18n/Locale';
import countryFlags from '@renderer-ui-library/assets/countryFlags';
import styles from './countryFlags.module.scss';

type CountryFlagProps = {
    locale: TLocale;
    localeName: string;
};

export const CountryFlag = ({ locale, localeName }: CountryFlagProps) => (
    <img
        src={countryFlags[locale].src}
        loading="lazy"
        alt={`${localeName} flag`}
        className={styles.countryFlag}
    />
);
